export const getUrl = (path) => process.env.REACT_APP_BASE_URL + path;

export const goToLink = (link) => window.location.assign(link);

export const getTestShareLink = (testId) => getUrl(`/test/${testId}`);

export const getBrowserTestShareLink = (testId) => getUrl(`/v2/browser-test/${testId}`);

export const getTemplatesLibraryLink = getUrl("/v2/templates");

export const getTemplateLink = (templateId) => getUrl(`/v2/template/${templateId}`);

export const getLoadTemplateLink = (templateId) => getUrl(`/v2/test/new?template_id=${templateId}`);

export const getReportLink = (draftId) => getUrl(`/v2/test/${draftId}/report`);

export const getTestPreviewLink = (testId) => getUrl(`/v2/preview/${testId}`);

export const getTestEditLink = (draftId) => getUrl(`/v2/test/${draftId}`);

export const getSlackIntegrationLink = (testId) => getUrl(`/slack/integration/authorize?testId=${testId}`);

export const getGoogleIntegrationLink = (testId) => getUrl(`/slack/integration/googleSheet?testId=${testId}`);

export const getIATestEditLink = (testId) => getUrl(`/v2/tests/${testId}`);

export const getModeratedReportLink = (testId) => getUrl(`/v2/moderated/${testId}/report`);

export const PATHS = {
  getUrl,
  goToLink,
  getReportLink,
  getTestEditLink,
  getTemplateLink,
  getTestShareLink,
  getTestPreviewLink,
  getLoadTemplateLink,
  getBrowserTestShareLink,
  getTemplatesLibraryLink,
  LOGOUT: getUrl("/site/logout"),
  PROFILE: getUrl("/user/profile"),
  NDA: getUrl("/user/profile/nda"),
  DASHBOARD: getUrl("/v2"),
  SURVEYS: getUrl("/v2/surveys"),
  MODERATED_DASHBOARD: getUrl("/v2/moderated"),
  HELP: "https://help.uxarmy.com",
  SUBSCRIPTIONS: getUrl("/credits/subscription/active"),
  UNMODERATED_TEST_SUBSCRIPTION: getUrl("/credits/subscription/"),
  MODERATED_TEST_SUBSCRIPTION: getUrl("/credits/subscription?product=deepdive&billing=monthly"),
  RECRUIT: getUrl("/userpanel/project/"),
  NEW_TEST: getUrl("/v2/test/new"),
  TEAM: getUrl("/user/teamAccount/index"),
  CARDSORTING: getUrl("/v2/toolkit/card-sorting"),
  TREETESTING: getUrl("/v2//toolkit/tree-testing"),
  SUPPORT: "https://help.uxarmy.com/",
  DEEPDIVE_SUPPORT: "https://help.uxarmy.com/space/DeepDive",
  CASE_STUDIES: "https://www.uxarmy.com/case-studies",
  FAQ: "https://help.uxarmy.com",
  TERMS: "https://www.uxarmy.com/terms",
  PRIVACY: "https://www.uxarmy.com/privacy",
  PRICING: "https://www.uxarmy.com/pricing",
  CONTACT_US: "https://www.uxarmy.com/contact-sales",
  CONTACT_SALES: "https://www.uxarmy.com/enterprise-sales",
  SUBSCRIPTION_PLATFORM_CREDITS_HELP: "https://help.uxarmy.com/space/general/196771866/Platform+Credits ",
  SUBSCRIPTION_USERPANEL_CREDITS_HELP: "https://help.uxarmy.com/space/general/196706362/Panel+Credits",
  HOW_CREDITS_WORK: "https://help.uxarmy.com/space/general/196902918/How+UXArmy's+Credit+System+Works",
  MODERATED_NEW_PROJECT: "/moderated/create-project",
  getSessionReportLink: (testId) => getUrl(`/test/${testId}/moderated/report`),
  getGoogleIntegrationLink,
  V2: {
    HOME: "/",
    PLANS: "/plans",
    TBT: "/dashboard",
    SURVEYS: "/surveys",
    MODERATED: "/moderated",
    TOOLKIT: {
      HOME: "/toolkit",
      CARDSORTING: "/toolkit/card-sorting",
      TREETESTING: "/toolkit/tree-testing",
    },
    EDIT_PROFILE: "/user/edit-profile",
    BILLINGS: "/user/billings",
    SUBSCRIPTIONS: "/user/subscriptions",
    INTEGRATIONS: "/user/integrations",
    GLOBAL_SETTINGS: "/user/global-settings",
    TOPUP: "/plans/topup",
    ORGANIZATION: "/user/organization",
    PEOPLE: "/user/organization/people",
    WORKSPACE: "/user/organization/workspace",
    switchWorkspaceRoute: (workspaceId) => `/workspace/${workspaceId}`,
    getUpgradePlanRoute: (planId, recurringType) => `/plans/upgrade/${planId}/${recurringType}`,
  },
};
